// GameData.js
var GameData = pc.createScript('gameData');

GameData.prototype.initialize = function() {
    GameData.instance = this;
};

// GameData.prototype.getLevelData = function (levelIndex) {

//     let levelName, objectCount, time, levelItem, levelTemplate,levelRoom;
    
//     switch (levelIndex) {
//         case 1:
//             levelName = "Hobby Room1";
//             objectCount = 4;
//             time = 30;
//             levelItem = "HobbyItem";
//             levelTemplate = "HobbyRoom";
//             levelRoom = "Hobby Room";
//             break;
//         case 2:
//             levelName = "Hobby Room2";
//             objectCount = 1;
//             time = 15;
//             levelItem = "HobbyItem";
//             levelTemplate = "HobbyRoom";
//             levelRoom = "Hobby Room";
//             break;
//         case 3:
//             levelName = "Hobby Room3";
//             objectCount = 1;
//             time = 15;
//             levelItem = "HobbyItem";
//             levelTemplate = "HobbyRoom";
//             levelRoom = "Hobby Room";
//             break;
//         case 4:
//             levelName = "Kids Room1";
//             objectCount = 1;
//             time = 15;
//             levelItem = "KidsItem";
//             levelTemplate = "KidsRoom";
//             levelRoom = "Kids Room";
//             break;
//         case 5:
//             levelName = "Kids Room2";
//             objectCount = 1;
//             time = 15;
//             levelItem = "KidsItem";
//             levelTemplate = "KidsRoom";
//             levelRoom = "Kids Room";
//             break;
//         case 6:
//             levelName = "School";
//             objectCount = 1;
//             time = 15;
//             levelItem = "SchoolItem";
//             levelTemplate = "School";
//             levelRoom = "School";
//             break;
//         case 7:
//             levelName = "Farmers Market";
//             objectCount = 1;
//             time = 15;
//             levelItem = "FarmersItem";
//             levelTemplate = "FarmersMarket";
//             levelRoom = "Farmers Market";
//             break;
//         case 8:
//             levelName = "Bedroom";
//             objectCount = 9;
//             time = 60;
//             levelItem = "BedroomItem";
//             levelTemplate = "Bedroom";
//             levelRoom = "Bedroom";
//             break;
//         case 9:
//             levelName = "Cellar";
//             objectCount = 1;
//             time = 15;
//             levelItem = "CellarItem";
//             levelTemplate = "Cellar";
//             levelRoom = "Cellar";
//             break;
//         case 10:
//             levelName = "Kitchen";
//             objectCount = 1;
//             time = 15;
//             levelItem = "KitchenItem";
//             levelTemplate = "Kitchen";
//             levelRoom = "Kitchen";
//             break;
//         case 11:
//             levelName = "Food Court";
//             objectCount = 1;
//             time = 15;
//             levelItem = "FoodItem";
//             levelTemplate = "Food";
//             levelRoom = "Food Court";
//             break;
//         case 12:
//             levelName = "Gym";
//             objectCount = 1;
//             time = 15;
//             levelItem = "SportItem";
//             levelTemplate = "Sport";
//             levelRoom = "Gym";
//             break;
//         case 13:
//             levelName = "Living Room";
//             objectCount = 1;
//             time = 15;
//             levelItem = "LivingItem";
//             levelTemplate = "LivingRoom";
//             levelRoom = "Living Room";
//             break;
//         default:
//         // code block
//     }
//     return {"levelName" : levelName, "objectCount" : objectCount, "time" : time, "levelItem" : levelItem, "levelTemplate" : levelTemplate, "levelRoom" : levelRoom, "levelID" : levelIndex};
// };

GameData.prototype.getLevelData = function (levelIndex) {

    let levelName, objectCount, time, levelItem, levelTemplate,levelRoom;
    
    switch (levelIndex) {
        case 1:
            levelName = "Hobby Room1";
            objectCount = 5;
            time = 60;
            levelItem = "HobbyItem";
            levelTemplate = "HobbyRoom";
            levelRoom = "Hobby Room";
            break;
        case 2:
            levelName = "Hobby Room2";
            objectCount = 6;
            time = 60;
            levelItem = "HobbyItem";
            levelTemplate = "HobbyRoom";
            levelRoom = "Hobby Room";
            break;
        case 3:
            levelName = "Hobby Room3";
            objectCount = 7;
            time = 60;
            levelItem = "HobbyItem";
            levelTemplate = "HobbyRoom";
            levelRoom = "Hobby Room";
            break;
        case 4:
            levelName = "Kids Room1";
            objectCount = 7;
            time = 60;
            levelItem = "KidsItem";
            levelTemplate = "KidsRoom";
            levelRoom = "Kids Room";
            break;
        case 5:
            levelName = "Kids Room2";
            objectCount = 8;
            time = 60;
            levelItem = "KidsItem";
            levelTemplate = "KidsRoom";
            levelRoom = "Kids Room";
            break;
        case 6:
            levelName = "School";
            objectCount = 8;
            time = 60;
            levelItem = "SchoolItem";
            levelTemplate = "School";
            levelRoom = "School";
            break;
        case 7:
            levelName = "Farmers Market";
            objectCount = 9;
            time = 60;
            levelItem = "FarmersItem";
            levelTemplate = "FarmersMarket";
            levelRoom = "Farmers Market";
            break;
        case 8:
            levelName = "Bedroom";
            objectCount = 9;
            time = 60;
            levelItem = "BedroomItem";
            levelTemplate = "Bedroom";
            levelRoom = "Bedroom";
            break;
        case 9:
            levelName = "Cellar";
            objectCount = 10;
            time = 60;
            levelItem = "CellarItem";
            levelTemplate = "Cellar";
            levelRoom = "Cellar";
            break;
        case 10:
            levelName = "Kitchen";
            objectCount = 10;
            time = 60;
            levelItem = "KitchenItem";
            levelTemplate = "Kitchen";
            levelRoom = "Kitchen";
            break;
        case 11:
            levelName = "Food Court";
            objectCount = 11;
            time = 60;
            levelItem = "FoodItem";
            levelTemplate = "Food";
            levelRoom = "Food Court";
            break;
        case 12:
            levelName = "Gym";
            objectCount = 11;
            time = 60;
            levelItem = "SportItem";
            levelTemplate = "Sport";
            levelRoom = "Gym";
            break;
        case 13:
            levelName = "Living Room";
            objectCount = 12;
            time = 60;
            levelItem = "LivingItem";
            levelTemplate = "LivingRoom";
            levelRoom = "Living Room";
            break;
        default:
        // code block
    }
    return {"levelName" : levelName, "objectCount" : objectCount, "time" : time, "levelItem" : levelItem, "levelTemplate" : levelTemplate, "levelRoom" : levelRoom, "levelID" : levelIndex};
};

GameData.prototype.getMiniGameData = function (miniGameIndex) {
    
        let eventName, objectCount, time, assetName, assetTag,matchKey;
    
    switch (miniGameIndex) {
        case 1:
            eventName = "Math Game";
            objectCount = 10;
            time = 60;
            assetName = "School";
            assetTag = "Number";
            matchKey = {"Key":{"0":1,"1":2,"2":3,"3":4,"4":5,"5":6,"6":7,"7":8,"8":9,"9":10,"10":11,"11":12,"12":13,"13":14,"14":15,"15":16,"16":17,"17":18,"18":19}};
            break;
        case 2:
            eventName = "Word Game";
            objectCount = 26;
            time = 60;
            assetName = "School";
            assetTag = "Alphabet";
            matchKey = {"TiKey":["UMBRELLA","VACCINE","DOCTOR","MICROSCOPE","HEARTBEAT","MOUTH","TOOTH","LUNGS","THOUGHT","SLEEPING","UNDERWEAR","GLASSES","SNEAKERS","FOOTPRINT","TOOTHBRUSH","MIRROR","EXTINGUISHER","FAUCET","BATHTUB","TEMPERATURE","LIFEBUOY","STROLLER","ARMCHAIR","NOTEBOOK","FOLDER","SUITCASE","BRIEFCASE","WALLET","HANDBAG","LOLLYPOP","BALLOON","SNOWMAN","GHOST","MEDICINE","PILL","ELEPHANT","PENGUIN","TORTOISE","DOLPHIN","SNAIL","BAT","SPIDER","BUTTERFLY","RABBIT","SQUIRREL","HORSE","PIG","DEER","HOUSE","TEMPLE","CHURCH","TOWER","CASTLE","GARAGE","COFFEE","PIZZA","CHEESE","BREAD","CROISSANT","CANDY","COCKTAIL","BEER","SOUP","WINE","APPLE","CHERRY","PEAR","GRAPE","PINEAPPLE","LEMON","CARROT","MUSHROOM","HAMBURGER","FLOWER","LEAF","FENCE","MOUNTAIN","ISLAND","CART","DOLLAR","PUZZLE","DICE","GUITAR","PIANO","VOLLEYBALL","FOOTBALL","BASKETBALL","BOWLING","RACKET","HAMMER","SCISSORS","RULER","PINCERS","SAW","DRILL","MAGNIFIER","WRENCH","CHAIN","PENCIL","PEN"]};
            break;
        case 4:
            eventName = "Attention Game";
            objectCount = 40;
            time = 60;
            assetName = "School";
            assetTag = "LivingRoom,Kitchen,KidsRoom,Food,FarmersMarket,Cellar";
            matchKey = {"LivingRoom":["Armchair","Chair","FlowerPot","FurnitureSofa","TV"],"Kitchen":["Blender","Microwave","Roller","Skimmer","Spoon"],"KidsRoom":["Babytoys","Bird","Controller","Kite","RacoonPlush"],"Hobby Room":["Bell","Casette","ElectroGuitar","Saxophone","Tumba"],"Food":["Creepe","HamEgg","IcecreamCherry","OrangeJuice","Turkey"],"FarmersMarket":["Cherry","DragonFruit","PineApple","Raddish","WaterMelon"],"Cellar":["BestCorn","CannedSalmon","Cereal","VitaminJuice","VitaminZero"]};
            break;
        case 6:
            eventName = "Link Game";
            objectCount = 40;
            time = 60;
            assetName = "Bedroom,Cellar,FarmersMarket,Food,HobbyRoom,KidsRoom,Kitchen,LivingRoom,School,Sport";
            assetTag = "Music,Toys,Sitting,Drinking,Electricity,Junk Food";
            matchKey = {"Music":{"0":"HobbyRoom"},"Toys":{"0":"KidsRoom"},"Sitting":{"0":"LivingRoom"},"Drinking":{"0":"Kitchen","1":"Food","2":"Cellar"},"Electricity":{"0":"LivingRoom","1":"Kitchen","2":"HobbyRoom"},"Junk Food":{"0":"Food"}};
            break;
        default:
        // code block
    }
    return {"miniGameName" : eventName, "objectCount" : objectCount, "time" : time, "assetName" : assetName, "assetTag" : assetTag, "matchKey" : matchKey, "miniGameIndex" : miniGameIndex};
};

function detectCurrentLevel() {

    var currentLevel, nextLevel, progressRatio, nextLevelLimit;

    if (PlayerManager.instance.userData.userScore >= 100000) {
        currentLevel = "Guru";
        nextLevel = "";
        progressRatio = 1;
        nextLevelLimit = "";
    }
    else if (PlayerManager.instance.userData.userScore >= 50000) {
        currentLevel = "Expert";
        nextLevel = "Guru";
        progressRatio = (PlayerManager.instance.userData.userScore - 50000) / (100000 - 50000);
        nextLevelLimit = 100000;
    }
    else if (PlayerManager.instance.userData.userScore >= 10000) {
        currentLevel = "Professional";
        nextLevel = "Expert";
        progressRatio = (PlayerManager.instance.userData.userScore - 10000) / (50000 - 10000);
        nextLevelLimit = 50000;
    }
    else if (PlayerManager.instance.userData.userScore >= 5000) {
        currentLevel = "Semi-Pro";
        nextLevel = "Professional";
        progressRatio = (PlayerManager.instance.userData.userScore - 5000) / (10000 - 5000);
        nextLevelLimit = 10000;
    }
    else if (PlayerManager.instance.userData.userScore >= 1000) {
        currentLevel = "Competent";
        nextLevel = "Semi-Pro";
        progressRatio = (PlayerManager.instance.userData.userScore - 1000) / (5000 - 1000);
        nextLevelLimit = 5000;
    }
    else if (PlayerManager.instance.userData.userScore >= 500) {
        currentLevel = "Advanced";
        nextLevel = "Competent";
        progressRatio = (PlayerManager.instance.userData.userScore - 500) / (1000 - 500);
        nextLevelLimit = 1000;
    }
    else if (PlayerManager.instance.userData.userScore >= 100) {
        currentLevel = "Beginner";
        nextLevel = "Advanced";
        progressRatio = (PlayerManager.instance.userData.userScore - 100) / (500 - 100);
        nextLevelLimit = 500;
    }
    else if (PlayerManager.instance.userData.userScore >= 0) {
        currentLevel = "Amateur";
        nextLevel = "Beginner";
        progressRatio = PlayerManager.instance.userData.userScore / 100;
        nextLevelLimit = 100;
    }

    return [currentLevel, nextLevel, progressRatio, nextLevelLimit];
}

